/* Configurateur Proconex — panneau à parité avec la maquette, en JS natif.
   S'appuie sur le composant <proconex-3d> (proconex-configurator.js).
   Les envois passent par sessionStorage('proconex:config') vers /pages/soumission. */
(function () {
  "use strict";
  var root = document.querySelector("[data-pcfg]");
  if (!root) return;

  /* ---------------- données (miroir exact de la maquette) ---------------- */
  var SIZES = {
    cabanon: ["8 × 10", "8 × 12", "10 × 10", "10 × 12", "10 × 14", "10 × 16", "12 × 16", "12 × 18", "12 × 20", "12 × 22", "12 × 24"],
    garage: ["16 × 20", "20 × 22", "20 × 24", "24 × 24", "24 × 28", "24 × 32", "32 × 32"]
  };
  var COLORS = ["Noir", "Charbon", "Gris ardoise", "Blanc", "Beige", "Sable", "Brun commercial", "Vert forêt", "Bleu acier", "Rouge grange", "Bois naturel"];
  var SIDINGS = ["Canexel", "Maibec", "Déclin de vinyle", "Déclin d'acier", "Tôle d'acier", "Brique", "Pierre décorative", "Panneaux verticaux"];
  var WALLS = ["7 pi", "8 pi", "9 pi", "10 pi", "12 pi"];
  var FRAMING = [{ v: "2x4", l: "2 × 4" }, { v: "2x6", l: "2 × 6" }];
  var ROOFS = ["Deux versants", "Toit 4 pentes", "Truss habitable", "Une pente", "Toit plat"];
  var PITCHES = ["4", "5", "6", "8", "10", "12"];
  var ROOFMATS = ["Bardeau d'asphalte", "Tôle d'acier"];
  var ROOFCOLORS = {
    "Bardeau d'asphalte": ["Bardeau noir", "Bardeau gris", "Bardeau brun"],
    "Tôle d'acier": ["Tôle noire", "Tôle brune", "Tôle verte", "Tôle rouge", "Tôle galvanisée", "Tôle blanche"]
  };
  var GDOORCOUNT = ["0", "1", "2"];
  var GDOORW = ["8 pi", "9 pi", "10 pi", "12 pi", "16 pi"];
  var GDOORH = ["6.5 pi", "7 pi", "8 pi", "9 pi", "10 pi"];
  var CABDOORS = ["Porte simple 34 po", "Porte 50 po", "Porte double", "Porte double vitrée", "Porte de garage 6 pi", "Porte de garage 7 pi", "Porte de garage 8 pi", "Porte de garage 9 pi", "Porte de garage 10 pi"];
  var SIDES = ["Avant", "Arrière", "Côté gauche", "Côté droit"];
  var YESNO = ["Oui", "Non"];
  var TRIM = ["Blanc", "Noir", "Charbon", "Brun commercial"];
  var WINSTYLES = ["Fixe", "Coulissante", "À battant"];
  var OVERHANGS = ["16 po"]; // garage: dimension validée au meeting du 4 septembre
  var CABOVER = ["6 po", "12 po"];
  var WINCOUNT = ["0", "1", "2", "3", "4"];
  var EXTRAS = ["Auvent", "Rampe d'accès", "Lucarne", "Volets décoratifs", "Gouttières"];
  var SVCW = ["34 po"];
  var SVCH = ["84 po"];
  var FLOORS = ["Plancher de bois (2 × 8, contreplaqué ¾ po)", "Plancher de béton"];
  var FINISHES = ["Avec finition", "Sans finition (latte + Tyvek)"];

  /* ==PCFG-WINDOW-MODEL-START==
     Modèle de fenêtres v2 — source de vérité unique.

     L'état d'exécution qui fait autorité est cfg.openings.windows : une liste de 0 à 4 objets
     { id, wall, pos, style, color, origin }. Les anciens champs plats (windows, winSide, winPos,
     winSide2, winPos2, winColor, winStyle) ne sont plus stockés : ce sont des accesseurs calculés
     sur cette liste (voir defineWindowAccessors). Il est donc structurellement impossible d'avoir
     windows = "4" pendant que la liste en contient 2, ou winSide = "Avant" alors que w1 dit "Droite".

     Phase 1 : état + adaptateurs seulement. La sérialisation reste compatible v1 et devient additive
     (voir packedConfig : champs plats inchangés + bloc v2 en supplément), et le moteur 3D continue de
     recevoir exactement les attributs plats qu'il attend déjà. Aucune refonte de l'interface ici. */
  var WIN_SCHEMA_VERSION = 2;
  var WIN_MAX = 4;
  // Constantes reprises telles quelles du moteur 3D (proconex-configurator.js, l. 8 / 526 / 715)
  // pour que la position dérivée des fenêtres 3 et 4 corresponde exactement à ce qu'il dessine.
  var WIN_GEOM = { F: 0.3048, EDGE: 0.28, W: 0.86 }; // pi→m · marge de coin · largeur de fenêtre
  var WIN_SEED = [{ wall: "Avant", pos: 15 }, { wall: "Côté droit", pos: 50 }];

  function winDepthFt(size) { var p = String(size || "").split("×"); return parseFloat(p[1]) || 16; }

  // Reproduit la dérivation du moteur pour les fenêtres au-delà de la 2e (proconex-configurator.js) :
  //   k = 0 → mur droit, décalage demandé −D × 0,18 ; k = 1 → mur gauche, décalage +D × 0,18.
  // spec() convertit un pourcentage en décalage : ask = −span + 2 · span · (p/100), span = lim − W/2.
  // On inverse cette formule pour retrouver le pourcentage équivalent, sans inventer de placement.
  function derivedWindow(k, depthFt) {
    var D = (parseFloat(depthFt) || 16) * WIN_GEOM.F;
    var span = (D / 2 - WIN_GEOM.EDGE) - WIN_GEOM.W / 2;
    var ask = (k % 2 === 0 ? -1 : 1) * D * 0.18;
    var pos = span > 0 ? 50 * (1 + ask / span) : 50;
    return { wall: k % 2 === 0 ? "Côté droit" : "Côté gauche", pos: Math.round(Math.max(0, Math.min(100, pos))) };
  }

  function makeWindow(i, wall, pos, style, color, origin) {
    return { id: "w" + (i + 1), wall: wall, pos: pos, style: style, color: color, origin: origin || "explicit", placement: "auto" };
  }

  // Construit la liste à partir d'un nombre + des données plates héritées.
  // Les deux premières fenêtres viennent des champs explicites ; les suivantes sont dérivées.
  function buildWindows(count, src) {
    var n = Math.max(0, Math.min(WIN_MAX, parseInt(count, 10) || 0));
    var flat = src.flat || [], out = [];
    for (var i = 0; i < n; i++) {
      if (i < 2) {
        var f = flat[i] || {}, seed = WIN_SEED[i];
        out.push(makeWindow(i, f.wall || seed.wall, f.pos != null ? f.pos : seed.pos, src.style, src.color, "explicit"));
      } else {
        var g = derivedWindow(i - 2, src.depthFt);
        out.push(makeWindow(i, g.wall, g.pos, src.style, src.color, "legacy-derived"));
      }
    }
    return out;
  }

  // Les anciens champs plats deviennent des accesseurs sur openings.windows.
  // Ils restent volontairement énumérables, pour la compatibilité ascendante : packedConfig() et
  // _selected parcourent Object.keys(cfg) et continuent donc de produire exactement le même jeu de
  // clés v1 qu'avant, dans le même ordre, sans modification de leur code.
  // openings et v sont NON énumérables : ils ne peuvent pas fuiter accidentellement par
  // Object.keys(cfg). Ils n'apparaissent dans la charge utile partagée que parce que packedConfig()
  // les y ajoute délibérément — c'est l'émission v2, en supplément des champs plats v1 conservés.
  function defineWindowAccessors(o) {
    function list() { return o.openings.windows; }
    // winPrefs ne sert qu'à conserver style/couleur quand la liste est vide (0 fenêtre),
    // cas où v1 gardait ces valeurs. Dès qu'une fenêtre existe, ce sont les objets qui font foi.
    function shared(prop) { var l = list(); return l.length ? l[0][prop] : o.openings.winPrefs[prop]; }
    function slot(i, prop, dflt) {
      return {
        get: function () { var l = list(); return l[i] ? l[i][prop] : dflt; },
        set: function (v) { var l = list(); if (l[i]) l[i][prop] = v; },
        enumerable: true, configurable: true
      };
    }
    function shareProp(prop) {
      return {
        get: function () { return shared(prop); },
        set: function (v) { o.openings.winPrefs[prop] = v; list().forEach(function (w) { w[prop] = v; }); },
        enumerable: true, configurable: true
      };
    }
    Object.defineProperties(o, {
      openings: { value: o.openings, writable: true, enumerable: false, configurable: true },
      v: { value: WIN_SCHEMA_VERSION, writable: true, enumerable: false, configurable: true },
      windows: {
        get: function () { return String(list().length); },
        // Le nombre actif reste openings.windows.length : c'est la seule source de vérité.
        // Réduire le nombre ne détruit plus les fenêtres de queue : elles sont mises de côté dans
        // openings._retired (mémoire de session, jamais sérialisée) et reviennent telles quelles si
        // le client remonte le compte. _retired n'est jamais lu comme état actif.
        set: function (n) {
          var cur = list(), want = Math.max(0, Math.min(WIN_MAX, parseInt(n, 10) || 0));
          var retired = o.openings._retired || (o.openings._retired = []);
          if (want < cur.length) {
            for (var r = want; r < cur.length; r++) retired[r] = cur[r];
            o.openings.windows = cur.slice(0, want);
            return;
          }
          if (want > cur.length) {
            var next = cur.slice();
            for (var i = cur.length; i < want; i++) {
              if (retired[i]) { next.push(retired[i]); retired[i] = null; continue; }
              next.push(buildWindows(i + 1, { flat: [next[0], next[1]], style: shared("style"), color: shared("color"), depthFt: winDepthFt(o.size) })[i]);
            }
            o.openings.windows = next;
          }
        },
        enumerable: true, configurable: true
      },
      winSide: slot(0, "wall", WIN_SEED[0].wall),
      winPos: slot(0, "pos", WIN_SEED[0].pos),
      winSide2: slot(1, "wall", WIN_SEED[1].wall),
      winPos2: slot(1, "pos", WIN_SEED[1].pos),
      winColor: shareProp("color"),
      winStyle: shareProp("style")
    });
    return o;
  }

  /* ================== Bilinguisme du panneau ==================
     Les valeurs internes de cfg ne changent JAMAIS de langue : la logique du moteur 3D les compare
     en clair (/double/i, /34/, /garage/i, SIDEI), le partage les encode, et le formulaire de
     soumission les envoie telles quelles au traitement de Proconex. Traduire ces valeurs casserait
     les quatre à la fois.

     On sépare donc autrement : chaque groupe porte désormais une CLÉ technique stable (k) qui sert
     aux appariements internes, et un LIBELLÉ (t) qui n'est plus que de l'affichage. Les valeurs
     d'options gardent leur graphie française en mémoire et passent par lab() pour être montrées.

     Les textes viennent du système de traduction déjà en place : fr.default.json et en.json, servis
     au panneau par window.PCX_T. Aucune nouvelle couche, aucune bibliothèque, aucun second arbre. */
  /* Le filtre « t » de Shopify rend du HTML échappé : « Tôle d'acier » arrive « Tôle d&#39;acier ».
     Le panneau écrit ces textes en textContent, donc l'entité s'afficherait telle quelle. On décode
     une fois, à la lecture du dictionnaire, et seulement les cinq entités que « t » produit — pas
     d'analyse HTML, donc rien à interpréter. */
  var ENT = { "&#39;": "'", "&#x27;": "'", "&apos;": "'", "&quot;": '"', "&amp;": "&", "&lt;": "<", "&gt;": ">" };
  function dec(v) {
    return typeof v === "string" && v.indexOf("&") >= 0
      ? v.replace(/&(?:#39|#x27|apos|quot|amp|lt|gt);/gi, function (m) { return ENT[m.toLowerCase()] || m; })
      : v;
  }
  function decAll(o) {
    var out = {};
    for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) {
      var v = o[k];
      out[k] = (v && typeof v === "object") ? decAll(v) : dec(v);
    }
    return out;
  }
  var T = decAll(window.PCX_T || {});
  var VLAB = T.values || {};

  /* Le résumé existe en deux exemplaires : celui que le client relit suit sa langue, celui qui
     part chez Proconex reste français, pour que toutes les demandes arrivent dans la même langue.
     Un seul code les produit — FR_ONLY neutralise le dictionnaire le temps d'un appel — donc la
     version interne est mot pour mot celle que le site français envoie aujourd'hui. */
  var FR_ONLY = false;
  function asFrench(fn) { FR_ONLY = true; try { return fn(); } finally { FR_ONLY = false; } }
  function tr(key, fr) { if (FR_ONLY) return fr; var v = T[key]; return (v == null || v === "") ? fr : v; }
  // Libellé d'affichage d'une valeur interne. Sans traduction disponible, la valeur française sort
  // telle quelle — le panneau reste donc lisible même si une clé manque.
  function lab(v) { var s = String(v == null ? "" : v); return FR_ONLY ? s : (VLAB[s] || s); }

  function defaults(kind) {
    var o = {
      kind: kind, size: kind === "garage" ? "20 × 22" : "10 × 12",
      wall: kind === "garage" ? "9 pi" : "8 pi", framing: kind === "garage" ? "2x6" : "2x4",
      roof: "Deux versants", pitch: kind === "garage" ? "6" : "5", overhang: kind === "garage" ? "16 po" : "12 po", overhangColor: "Noir",
      siding: "Canexel", color: "Noir", finish: "Avec finition", floor: FLOORS[0],
      roofMat: "Bardeau d'asphalte", roofColor: "Bardeau noir",
      gdoors: "1", gdoorW: "9 pi", gdoorH: "7 pi", door: "Porte simple 34 po",
      doorColor: "Blanc", doorSide: "Avant", doorPos: 50,
      service: "Non", serviceColor: "Blanc", svcSide: "Avant", svcPos: 85, svcWpo: "34 po", svcHpo: "84 po",
      // « auto » tant que le client n'a pas glissé la porte lui-même ; « manual » ensuite.
      svcPlacement: "auto",
      // Fenêtres : aucune fenêtre client tant que le nombre n'a pas été choisi explicitement
      // (exigence A3, sous-système fenêtres seulement). Le compte réel vient toujours de la liste.
      // Les valeurs de position par défaut d'une fenêtre ajoutée viennent de WIN_SEED, pas d'ici.
      windows: "0", winColor: "Blanc", winStyle: "Fixe",
      winSide: "Avant", winPos: 15, winSide2: "Côté droit", winPos2: 50,
      extras: []
    };
    // les valeurs plates du littéral ci-dessus servent d'amorce, puis c'est la liste qui fait autorité
    o.openings = {
      winPrefs: { style: o.winStyle, color: o.winColor },
      windows: buildWindows(o.windows, {
        flat: [{ wall: o.winSide, pos: o.winPos }, { wall: o.winSide2, pos: o.winPos2 }],
        style: o.winStyle, color: o.winColor, depthFt: winDepthFt(o.size)
      })
    };
    return defineWindowAccessors(o);
  }

  /* Migration/normalisation — point d'entrée unique et isolé.
     Une charge utile sans `v` est traitée comme v1. Correspondance v1 :
       windows            → nombre de fenêtres (0 à 4)
       winSide + winPos   → w1
       winSide2 + winPos2 → w2
       winStyle, winColor → appliqués à toutes les fenêtres migrées (sémantique v1 : partagés)
       fenêtres 3 et 4    → derivedWindow(), qui rejoue la dérivation actuelle du moteur */
  // Un lien v1 sans clé « windows » (cas théorique : packedConfig l'a toujours émise) reçoit
  // l'ancien défaut historique, pas le défaut « aucune » d'une session neuve.
  var LEGACY_DEFAULT_WINDOWS = "2";
  function migrateConfig(saved) {
    var base = defaults(saved && saved.kind === "garage" ? "garage" : "cabanon");
    if (!saved || typeof saved !== "object") return base;
    var WIN_KEYS = { windows: 1, winSide: 1, winPos: 1, winSide2: 1, winPos2: 1, winColor: 1, winStyle: 1 };
    // tout le reste de la configuration est copié tel quel, y compris size (nécessaire à la dérivation)
    Object.keys(base).forEach(function (k) { if (!WIN_KEYS[k] && saved[k] !== undefined) base[k] = saved[k]; });
    var ver = parseInt(saved.v, 10) || 1;
    var isV2 = ver >= 2 && saved.openings && Object.prototype.toString.call(saved.openings.windows) === "[object Array]";
    if (isV2) {
      var src = saved.openings.windows.slice(0, WIN_MAX);
      base.openings.winPrefs = {
        style: (saved.openings.winPrefs && saved.openings.winPrefs.style) || (src[0] && src[0].style) || "Fixe",
        color: (saved.openings.winPrefs && saved.openings.winPrefs.color) || (src[0] && src[0].color) || "Blanc"
      };
      base.openings.windows = src.map(function (w, i) {
        var seed = WIN_SEED[Math.min(i, 1)];
        return makeWindow(i, w.wall || seed.wall, w.pos != null ? w.pos : seed.pos,
          w.style || base.openings.winPrefs.style, w.color || base.openings.winPrefs.color, w.origin || "explicit");
      });
    } else {
      base.openings.winPrefs = { style: saved.winStyle || "Fixe", color: saved.winColor || "Blanc" };
      base.openings.windows = buildWindows(saved.windows !== undefined ? saved.windows : LEGACY_DEFAULT_WINDOWS, {
        flat: [{ wall: saved.winSide, pos: saved.winPos }, { wall: saved.winSide2, pos: saved.winPos2 }],
        style: base.openings.winPrefs.style, color: base.openings.winPrefs.color, depthFt: winDepthFt(base.size)
      });
    }
    return base;
  }
  /* ==PCFG-WINDOW-MODEL-END== */
  /* ================== Partage de configuration — schéma v1 ==================
     L'ancien lien encodait en base64 la TOTALITÉ de cfg : les 30 valeurs en toutes lettres
     (« Plancher de bois (2 × 8, contreplaqué ¾ po) »…), la liste des fenêtres une seconde fois, et
     la carte des choix touchés. Une configuration par défaut, sans le moindre clic, produisait déjà
     une URL de 1102 caractères — illisible dans Messages et impossible à relire.

     v1 n'encode que l'état CANONIQUE, en index d'énumération et en base 36, séparés par des points.
     Rien de dérivé : ni DOM, ni maillage, ni géométrie, ni cache, ni valeur recalculable. Les champs
     de queue laissés à leur valeur par défaut sont omis, le décodeur les rétablit.

     CONTRAT DE VERSION : les listes d'options ci-dessus sont indexées. On peut y AJOUTER en fin de
     liste sans rien casser ; insérer ou réordonner change le sens des anciens liens et impose donc
     de passer à v2. Un index hors bornes ne fait jamais planter le configurateur : la valeur par
     défaut est reprise et la lecture continue.
     ========================================================================== */
  var SHARE_V = 1;
  // Ordre figé : c'est lui qui donne son sens au masque des choix confirmés.
  var SEL_KEYS = ["size", "wall", "framing", "roof", "pitch", "overhang", "overhangColor",
    "siding", "color", "finish", "floor", "roofMat", "roofColor",
    "gdoors", "gdoorW", "gdoorH", "door", "doorColor", "doorSide", "doorPos",
    "service", "serviceColor", "svcSide", "svcPos",
    "windows", "winColor", "winStyle", "extras",
    "winSide", "winPos", "winSide2", "winPos2", "winSide3", "winPos3", "winSide4", "winPos4"];
  var PLACEMENTS = ["auto", "fixed", "manual"];

  function sizeList(kind) { return SIZES[kind].concat(["Sur mesure"]); }
  function overhangList(kind) { return kind === "garage" ? OVERHANGS : CABOVER; }
  function idx(list, v, dflt) { var i = list.indexOf(v); return i < 0 ? (dflt || 0) : i; }
  /* Attention : parseInt(undefined, 36) NE renvoie PAS NaN — « undefined » ne contient que des
     chiffres valides en base 36 et se lit comme un très grand nombre. Un champ absent était donc
     lu comme une valeur énorme, ramenée par bornage au maximum : un lien sans fenêtres en
     rétablissait quatre, et le masque des choix confirmés arrivait entièrement à 1. Tout champ
     doit donc être validé comme chaîne de base 36 AVANT d'être converti. */
  var B36 = /^[0-9a-z]+$/;
  function num36(s) { return (typeof s === "string" && B36.test(s)) ? parseInt(s, 36) : NaN; }
  function at(list, i, dflt) { var n = num36(i); return (isFinite(n) && n >= 0 && n < list.length) ? list[n] : dflt; }
  function b36(n) { return (Math.max(0, Math.round(n)) || 0).toString(36); }
  function int36(s, dflt, lo, hi) {
    var n = num36(s);
    if (!isFinite(n)) return dflt;
    return Math.max(lo, Math.min(hi, n));
  }
  function maskOf(keys, has) { var m = 0; keys.forEach(function (k, i) { if (has(k)) m += Math.pow(2, i); }); return m; }
  function maskHas(m, i) { return Math.floor(m / Math.pow(2, i)) % 2 === 1; }

  function encodeConfig() {
    var k = cfg.kind, rc = roofColors();
    var f = [
      b36(SHARE_V),
      k === "garage" ? "1" : "0",
      b36(idx(sizeList(k), cfg.size)),
      b36(idx(WALLS, cfg.wall)),
      b36(idx(FRAMING.map(function (x) { return x.v; }), cfg.framing)),
      b36(idx(ROOFS, cfg.roof)),
      b36(idx(PITCHES, cfg.pitch)),
      b36(idx(overhangList(k), cfg.overhang)),
      b36(idx(TRIM, cfg.overhangColor)),
      b36(idx(SIDINGS, cfg.siding)),
      b36(idx(COLORS, cfg.color)),
      b36(idx(FINISHES, cfg.finish)),
      b36(idx(FLOORS, cfg.floor)),
      b36(idx(ROOFMATS, cfg.roofMat)),
      b36(idx(rc, cfg.roofColor)),
      b36(idx(GDOORCOUNT, cfg.gdoors)),
      b36(idx(GDOORW, cfg.gdoorW)),
      b36(idx(GDOORH, cfg.gdoorH)),
      b36(idx(CABDOORS, cfg.door)),
      b36(idx(TRIM, cfg.doorColor)),
      b36(idx(SIDES, cfg.doorSide)),
      b36(cfg.doorPos),
      b36(idx(YESNO, cfg.service)),
      b36(idx(TRIM, cfg.serviceColor)),
      b36(idx(SIDES, cfg.svcSide)),
      b36(cfg.svcPos),
      b36(idx(PLACEMENTS, cfg.svcPlacement || "auto")),
      b36(idx(WINSTYLES, cfg.winStyle)),
      b36(idx(TRIM, cfg.winColor)),
      b36(maskOf(EXTRAS, function (x) { return cfg.extras.indexOf(x) >= 0; })),
      b36(maskOf(SEL_KEYS, function (key) { return !!selected[key]; }))
    ];
    // Les fenêtres : mur, position, mode. Style et couleur sont communs à toutes (le réglage les
    // écrit sur chacune), ils sont donc portés une seule fois par les champs ci-dessus.
    var wl = cfg.openings.windows;
    f.push(b36(wl.length));
    wl.forEach(function (w) {
      f.push(b36(idx(SIDES, w.wall)), b36(w.pos), b36(idx(PLACEMENTS, w.placement || "auto")));
    });
    // Les champs de queue restés au défaut ne servent à rien dans le lien.
    var def = defaults(k), refWl = def.openings.windows;
    var dflt = [b36(SHARE_V), k === "garage" ? "1" : "0",
      b36(idx(sizeList(k), def.size)), b36(idx(WALLS, def.wall)),
      b36(idx(FRAMING.map(function (x) { return x.v; }), def.framing)), b36(idx(ROOFS, def.roof)),
      b36(idx(PITCHES, def.pitch)), b36(idx(overhangList(k), def.overhang)), b36(idx(TRIM, def.overhangColor)),
      b36(idx(SIDINGS, def.siding)), b36(idx(COLORS, def.color)), b36(idx(FINISHES, def.finish)),
      b36(idx(FLOORS, def.floor)), b36(idx(ROOFMATS, def.roofMat)),
      b36(idx(ROOFCOLORS[def.roofMat] || rc, def.roofColor)),
      b36(idx(GDOORCOUNT, def.gdoors)), b36(idx(GDOORW, def.gdoorW)), b36(idx(GDOORH, def.gdoorH)),
      b36(idx(CABDOORS, def.door)), b36(idx(TRIM, def.doorColor)), b36(idx(SIDES, def.doorSide)),
      b36(def.doorPos), b36(idx(YESNO, def.service)), b36(idx(TRIM, def.serviceColor)),
      b36(idx(SIDES, def.svcSide)), b36(def.svcPos), b36(idx(PLACEMENTS, def.svcPlacement || "auto")),
      b36(idx(WINSTYLES, def.winStyle)), b36(idx(TRIM, def.winColor)), "0", "0", b36(refWl.length)];
    while (f.length > 2 && f.length <= dflt.length && f[f.length - 1] === dflt[f.length - 1]) f.pop();
    return f.join(".");
  }

  /* Décodeur tolérant : version inconnue → on ignore le lien et on démarre sur les valeurs par
     défaut ; index hors bornes → valeur par défaut pour ce champ seulement ; champs manquants →
     défauts. Il ne jette jamais. */
  function decodeConfig(str) {
    var f = String(str || "").split(".");
    if (parseInt(f[0], 36) !== SHARE_V) return null;
    var kind = f[1] === "1" ? "garage" : "cabanon";
    var o = defaults(kind), g = function (i) { return f[i]; };
    var rcList;
    o.size = at(sizeList(kind), g(2), o.size);
    o.wall = at(WALLS, g(3), o.wall);
    o.framing = at(FRAMING.map(function (x) { return x.v; }), g(4), o.framing);
    o.roof = at(ROOFS, g(5), o.roof);
    o.pitch = at(PITCHES, g(6), o.pitch);
    o.overhang = at(overhangList(kind), g(7), o.overhang);
    o.overhangColor = at(TRIM, g(8), o.overhangColor);
    o.siding = at(SIDINGS, g(9), o.siding);
    o.color = at(COLORS, g(10), o.color);
    o.finish = at(FINISHES, g(11), o.finish);
    o.floor = at(FLOORS, g(12), o.floor);
    o.roofMat = at(ROOFMATS, g(13), o.roofMat);
    rcList = ROOFCOLORS[o.roofMat] || ROOFCOLORS["Bardeau d'asphalte"];
    o.roofColor = at(rcList, g(14), rcList[0]);
    o.gdoors = at(GDOORCOUNT, g(15), o.gdoors);
    o.gdoorW = at(GDOORW, g(16), o.gdoorW);
    o.gdoorH = at(GDOORH, g(17), o.gdoorH);
    o.door = at(CABDOORS, g(18), o.door);
    o.doorColor = at(TRIM, g(19), o.doorColor);
    o.doorSide = at(SIDES, g(20), o.doorSide);
    o.doorPos = int36(g(21), o.doorPos, 0, 100);
    o.service = at(YESNO, g(22), o.service);
    o.serviceColor = at(TRIM, g(23), o.serviceColor);
    o.svcSide = at(SIDES, g(24), o.svcSide);
    o.svcPos = int36(g(25), o.svcPos, 0, 100);
    o.svcPlacement = at(PLACEMENTS, g(26), "auto");
    var style = at(WINSTYLES, g(27), o.winStyle), wcol = at(TRIM, g(28), o.winColor);
    var exMask = int36(g(29), 0, 0, Math.pow(2, EXTRAS.length) - 1);
    o.extras = EXTRAS.filter(function (x, i) { return maskHas(exMask, i); });
    var selMask = int36(g(30), 0, 0, Math.pow(2, SEL_KEYS.length) - 1);
    // Fenêtres : le nombre puis trois champs chacune. Un lien tronqué donne simplement moins de
    // fenêtres, jamais une liste incohérente.
    var n = int36(g(31), o.openings.windows.length, 0, WIN_MAX);
    o.windows = String(n);
    for (var i = 0; i < n; i++) {
      var w = o.openings.windows[i]; if (!w) break;
      var b = 32 + i * 3;
      w.wall = at(SIDES, g(b), w.wall);
      w.pos = int36(g(b + 1), w.pos, 0, 100);
      w.placement = at(PLACEMENTS, g(b + 2), "auto");
      w.style = style; w.color = wcol;
    }
    o.winStyle = style; o.winColor = wcol;
    var sel = {};
    SEL_KEYS.forEach(function (key, i) { if (maskHas(selMask, i)) sel[key] = true; });
    return { cfg: o, selected: sel };
  }

  function packedConfig() { return encodeConfig(); }
  /* Le lien porte la charge utile dans le FRAGMENT : elle n'est jamais envoyée au serveur, elle
     échappe au cache de page de Shopify, et les paramètres déjà présents (preview_theme_id en
     aperçu) sont conservés intacts. */
  function configLink() {
    var u = new URL(window.location.href);
    u.searchParams.delete("cfg");       // plus d'ancien paramètre dans les liens que l'on émet
    u.hash = "c=" + packedConfig();
    return u.toString();
  }

  var cfg = defaults(root.getAttribute("data-pcfg") === "garage" ? "garage" : "cabanon");
  var selected = {};
  function mark(key){ selected[key] = true; }
  function isSel(key, value){ return !!selected[key] && cfg[key] === value; }
  /* Restauration d'un lien partagé.
     D'abord le fragment v1 (#c=). À défaut, l'ancien paramètre ?cfg= : sa lecture tient en quelques
     lignes et passe par migrateConfig, déjà éprouvé, donc les liens déjà envoyés continuent de
     s'ouvrir. On n'en ÉMET plus : configLink() ne produit que du v1.
     Les positions du lien font autorité — chaque ouverture restaurée reprend son mode réel
     (auto / fixed / manual), et le placement automatique laisse tranquille tout ce qui n'est pas
     « auto » tant que c'est valide. Rien n'est donc réécrit derrière le dos de l'expéditeur. */
  try {
    var frag = /(?:^|[#&])c=([^&]+)/.exec(window.location.hash || "");
    var v1 = frag && decodeConfig(decodeURIComponent(frag[1]));
    if (v1) {
      cfg = v1.cfg; selected = v1.selected;
    } else {
      var qcfg = new URLSearchParams(window.location.search).get("cfg");
      if (qcfg) {
        var rawCfg = qcfg.replace(/-/g, "+").replace(/_/g, "/"); while (rawCfg.length % 4) rawCfg += "=";
        var savedCfg = JSON.parse(decodeURIComponent(escape(atob(rawCfg))));
        if (savedCfg && typeof savedCfg === "object") {
          var base = migrateConfig(savedCfg);
          cfg = base;
          // L'ancien format ne portait aucun mode de placement : ses ouvertures repartaient donc en
          // « auto » et le placement automatique renormalisait leurs positions à l'ouverture du lien.
          // Une position venue d'un lien fait autorité, quel que soit le format : on les marque
          // comme posées, ce qui les laisse exactement où l'expéditeur les avait mises.
          cfg.svcPlacement = "fixed";
          cfg.openings.windows.forEach(function (w) { w.placement = "fixed"; });
          if (savedCfg._selected && typeof savedCfg._selected === "object") selected = savedCfg._selected;
          else { Object.keys(base).forEach(function (k) { selected[k] = true; }); }
        }
      }
    }
  } catch (e) { }
  var openStep = 0;

  /* ---------------- règles (mêmes calculs que la maquette) ---------------- */
  function dims() { var p = (cfg.size || "").split("×"); return [parseFloat(p[0]) || 20, parseFloat(p[1]) || 20]; }
  function isGar() { return cfg.kind === "garage"; }
  function wallFtOf(side) { var d = dims(); return (side === "Avant" || side === "Arrière") ? d[0] : d[1]; }
  function maxPitchCab() { var d = dims(); return (d[0] >= 12 && d[1] >= 12) ? 4 : 5; }
  function pitchOk(v) { return isGar() || parseFloat(v) <= maxPitchCab(); }
  function effPitch() { return pitchOk(cfg.pitch) ? cfg.pitch : String(maxPitchCab()); }
  function effFraming() { return isGar() ? cfg.framing : "2x4"; }
  function effWall() { return isGar() ? cfg.wall : (["7 pi", "8 pi"].indexOf(cfg.wall) >= 0 ? cfg.wall : "8 pi"); }
  function effOverhang() { return isGar() ? "16 po" : (CABOVER.indexOf(cfg.overhang) >= 0 ? cfg.overhang : "12 po"); }
  // Portes de garage : plus aucune substitution silencieuse ni blocage fondé sur les marges de
  // rendu EDGE/GAP (0,28 m / 0,24 m), qui ne sont pas des règles Proconex approuvées. La largeur
  // et le nombre demandés sont envoyés tels quels à la 3D ; si une porte dépasse réellement le mur
  // ou en chevauche une autre, le moteur le signale (registre d'ouvertures) et le client corrige.
  // Les dégagements d'affaires exacts (porte ↔ coin, porte ↔ porte, porte ↔ porte de service)
  // restent à confirmer par Proconex.
  function hFits(o) { return parseFloat(o) <= (parseFloat(effWall()) || 8) - 1; }
  function effGdoorH() { return hFits(cfg.gdoorH) ? cfg.gdoorH : "7 pi"; }
  function mainDoorFt() {
    if (isGar()) return (parseFloat(cfg.gdoorW) || 9) * (cfg.gdoors === "2" ? 2 : cfg.gdoors === "0" ? 0 : 1);
    if (/double/i.test(cfg.door)) return 5;
    var mm = /([\d.]+)\s*p[oi]/.exec(cfg.door); if (!mm) return 3;
    return /po/.test(mm[0]) ? parseFloat(mm[1]) / 12 : parseFloat(mm[1]);
  }
  function svcRoom() { return wallFtOf(cfg.svcSide) - 2 - (cfg.svcSide === cfg.doorSide ? mainDoorFt() + 1 : 0) >= (34/12 + 0.35); }
  function winRoom() {
    return wallFtOf(cfg.winSide) - 2 - (cfg.winSide === cfg.doorSide ? mainDoorFt() + 1 : 0)
      - (cfg.service === "Oui" && cfg.winSide === cfg.svcSide ? 4 : 0) >= 3;
  }

  /* ================== Placement automatique des ouvertures ==================
     Une ouverture ajoutée pouvait exister dans l'état sans être visible : le moteur 3D applique une
     règle dure — deux ouvertures d'un même mur ne peuvent pas occuper la même surface — et se
     contente de NE PAS DESSINER celle qui arrive en second.

     Toute la géométrie vient de proconex-openings.js, partagé avec le moteur 3D : mêmes constantes,
     mêmes formules de position, même règle de collision. Les emprises des portes sont RECALCULÉES
     depuis l'état canonique à chaque passe, et non lues dans le registre publié après un rendu :
     au premier affichage, avant que Three.js soit chargé, ce registre n'existe pas encore et le
     placement croyait le mur vide.

     La collision est le vrai rectangle : deux ouvertures ne se gênent que si elles se recouvrent à
     la fois horizontalement ET verticalement. Une fenêtre haute peut donc passer au-dessus d'une
     ouverture basse exactement quand la 3D l'accepte, ni plus ni moins.
     ========================================================================= */
  var PO = window.ProconexOpenings;
  var noRoom = { svc: false, windows: [] };   // ouvertures sans emplacement valide sur leur mur

  // Les entrées de la géométrie sont exactement celles que syncViewer() envoie à la 3D.
  function geomState() {
    var d = dims();
    return {
      kind: cfg.kind, wFt: d[0], dFt: d[1], wallFt: parseFloat(effWall()),
      gdoors: isGar() ? cfg.gdoors : 0,
      gdoorWFt: parseFloat(cfg.gdoorW), gdoorHFt: parseFloat(effGdoorH()),
      doorSide: cfg.doorSide, doorPos: cfg.doorPos, doorSpec: doorSpec()
    };
  }
  function boxOf(item, wall, pos) {
    var st = geomState();
    return item.type === "win"
      ? PO.windowBox(st, wall, pos, "window" + (item.index + 1))
      : PO.serviceBox(st, wall, pos);
  }
  function currentBox(item, wall) {
    return boxOf(item, wall, item.type === "win" ? cfg.openings.windows[item.index].pos : cfg.svcPos);
  }

  /* Obstacles d'un mur pour une ouverture donnée : les ouvertures structurelles, plus celles dont la
     position est déjà arrêtée dans cette passe, RESTREINTES à celles qui recouvrent aussi sa bande
     verticale. Une ouverture pas encore traitée est délibérément absente — sinon elle bloquerait un
     intervalle à sa position périmée. */
  function obstaclesOn(wall, band, settled) {
    var st = geomState(), k = PO.wallKey(wall), all = PO.structuralBoxes(st);
    if (cfg.service === "Oui" && settled.svc) all.push(PO.serviceBox(st, cfg.svcSide, cfg.svcPos));
    cfg.openings.windows.forEach(function (w, i) {
      if (w && settled["w" + i]) all.push(PO.windowBox(st, w.wall, w.pos, "window" + (i + 1)));
    });
    return all
      .filter(function (p) { return p.wall === k && band[0] < p.yt - PO.EPS && p.yb < band[1] - PO.EPS; })
      .map(function (p) { return [p.a, p.b]; })
      .sort(function (a, b) { return a[0] - b[0]; });
  }

  // Intervalles libres pour une emprise de largeur `span`, GAP compris de part et d'autre.
  function freeIntervals(wall, occupied, span) {
    var half = PO.wallLen(geomState(), PO.wallKey(wall)) / 2;
    var lo = -half + PO.EDGE, hi = half - PO.EDGE;
    var free = [], cur = lo;
    occupied.forEach(function (o) {
      var a = o[0] - PO.GAP, b = o[1] + PO.GAP;
      if (a > cur) free.push([cur, Math.min(a, hi)]);
      if (b > cur) cur = b;
    });
    if (cur < hi) free.push([cur, hi]);
    return free.filter(function (f) { return f[1] - f[0] >= span - PO.EPS; });
  }
  function isFree(free, centre, span) {
    return free.some(function (f) { return centre - span / 2 >= f[0] - PO.EPS && centre + span / 2 <= f[1] + PO.EPS; });
  }
  // Position valide la plus proche — sert à réparer une ouverture manuelle qu'un redimensionnement
  // a rendue invalide, sans la déplacer plus que nécessaire.
  function nearestCentre(free, want) {
    var bestC = null, bestD = Infinity;
    free.forEach(function (f) {
      var c = Math.max(f[0], Math.min(f[1], want)), d = Math.abs(c - want);
      if (d < bestD) { bestD = d; bestC = c; }
    });
    return bestC;
  }

  /* MOTEUR COMMUN — autoPlaceOpenings(wall, items, settled).
     Une seule ouverture est le cas n = 1 ; il n'y a pas de chemin particulier par type d'ouverture.
     Au lieu de placer chaque ouverture l'une après l'autre au centre du plus grand intervalle — ce
     qui coupait l'espace en deux moitiés inutilisables et faisait déclarer « plus de place » sur un
     mur qui pouvait encore en recevoir une — on place ensemble toutes les ouvertures automatiques
     d'un même mur. Dans chaque intervalle libre on prend autant d'ouvertures qu'il peut en contenir,
     puis on les espace également ; si l'espace est juste, on resserre au jeu minimal et on centre le
     groupe. Les intervalles tiennent déjà compte de GAP contre les obstacles. */
  function autoPlaceOpenings(wall, items, settled) {
    var out = [], idx = 0;
    if (!items.length) return { placed: out, missing: [] };
    // Toutes les ouvertures d'un même lot partagent leur bande verticale par type ; on prend la plus
    // large pour choisir les obstacles, ce qui ne peut pas rater une gêne réelle.
    var bands = items.map(function (it) { var b = boxOf(it, wall, 50); return [b.yb, b.yt]; });
    var band = [Math.min.apply(null, bands.map(function (b) { return b[0]; })),
                Math.max.apply(null, bands.map(function (b) { return b[1]; }))];
    var spans = items.map(function (it) { return boxOf(it, wall, 50).w; });
    var free = freeIntervals(wall, obstaclesOn(wall, band, settled), Math.min.apply(null, spans));
    free.forEach(function (f) {
      if (idx >= items.length) return;
      var len = f[1] - f[0], take = [], used = 0;
      for (var k = idx; k < items.length; k++) {
        var need = used === 0 ? spans[k] : used + PO.GAP + spans[k];
        if (need <= len + PO.EPS) { take.push({ it: items[k], span: spans[k] }); used = need; } else break;
      }
      if (!take.length) return;
      var total = take.reduce(function (s, t) { return s + t.span; }, 0);
      var g = (len - total) / (take.length + 1), cur;
      if (g >= PO.GAP) { cur = f[0] + g; }
      else { g = PO.GAP; cur = f[0] + (len - (total + (take.length - 1) * PO.GAP)) / 2; }
      take.forEach(function (t) { out.push({ item: t.it, centre: cur + t.span / 2 }); cur += t.span + g; });
      idx += take.length;
    });
    return { placed: out, missing: items.slice(idx) };
  }

  function applyCentre(item, wall, centre) {
    var st = geomState();
    if (item.type === "win") cfg.openings.windows[item.index].pos = Math.round(PO.windowPosFromWorld(st, wall, centre));
    else cfg.svcPos = Math.round(PO.servicePosFromWorld(st, wall, centre));
  }

  // Une ouverture manuelle valide n'est pas touchée ; devenue invalide, elle rejoint la position
  // valide la plus proche plutôt que de disparaître.
  function repairManual(item, wall, settled) {
    var b = currentBox(item, wall);
    var free = freeIntervals(wall, obstaclesOn(wall, [b.yb, b.yt], settled), b.w);
    if (isFree(free, b.cx, b.w)) return true;
    var c = nearestCentre(free, b.cx);
    if (c === null) return false;
    applyCentre(item, wall, c);
    return true;
  }

  /* Passe unique après chaque changement. */
  function reflowOpenings() {
    if (!cfg.openings || !cfg.openings.windows || !PO) return;
    var svcOn = cfg.service === "Oui";
    var miss = { svc: false, windows: [] };
    var winL = cfg.openings.windows;
    // Trois états : « auto » = à placer maintenant (créée, ou mur changé) · « fixed » = déjà placée
    // automatiquement et laissée tranquille tant qu'elle reste valide · « manual » = glissée par le
    // client. Sans le cas « fixed », glisser une fenêtre redistribuait toutes les autres du mur.
    var svcState = svcOn ? (cfg.svcPlacement || "auto") : null;
    var settled = {};
    function winState(w) { return w.placement || "auto"; }
    function stillValid(item, wall) {
      var b = currentBox(item, wall);
      return isFree(freeIntervals(wall, obstaclesOn(wall, [b.yb, b.yt], settled), b.w), b.cx, b.w);
    }

    // 1) Les glissements du client d'abord : obstacles fixes, réparés au plus proche seulement si un
    //    redimensionnement les a rendus invalides.
    if (svcState === "manual") {
      if (repairManual({ type: "svc" }, cfg.svcSide, settled)) settled.svc = true; else miss.svc = true;
    }
    winL.forEach(function (w, i) {
      if (!w || winState(w) !== "manual") return;
      if (repairManual({ type: "win", index: i }, w.wall, settled)) settled["w" + i] = true; else miss.windows.push(i);
    });

    // 2) Les ouvertures déjà placées automatiquement et encore valides restent où elles sont.
    var aReplacer = { svc: svcState === "auto", windows: [] };
    if (svcState === "fixed") { if (stillValid({ type: "svc" }, cfg.svcSide)) settled.svc = true; else aReplacer.svc = true; }
    winL.forEach(function (w, i) {
      var st = winState(w);
      if (st === "manual") return;
      if (st === "fixed" && stillValid({ type: "win", index: i }, w.wall)) settled["w" + i] = true;
      else aReplacer.windows.push(i);
    });

    // 3) Enfin les ouvertures à placer, réparties mur par mur et toutes ensemble.
    var parMur = {};
    if (aReplacer.svc) (parMur[cfg.svcSide] = parMur[cfg.svcSide] || []).push({ type: "svc" });
    aReplacer.windows.forEach(function (i) {
      var w = winL[i];
      (parMur[w.wall] = parMur[w.wall] || []).push({ type: "win", index: i });
    });
    Object.keys(parMur).forEach(function (mur) {
      var r = autoPlaceOpenings(mur, parMur[mur], settled);
      r.placed.forEach(function (pl) {
        applyCentre(pl.item, mur, pl.centre);
        if (pl.item.type === "win") { settled["w" + pl.item.index] = true; winL[pl.item.index].placement = "fixed"; }
        else { settled.svc = true; cfg.svcPlacement = "fixed"; }
      });
      r.missing.forEach(function (it) {
        if (it.type === "win") miss.windows.push(it.index); else miss.svc = true;
      });
    });
    miss.windows.sort(function (a, b) { return a - b; });

    // Sans emplacement valide, la position reste telle quelle — l'ouverture n'est ni déplacée sous
    // une autre ni supprimée de l'état — et le panneau le dit sur le contrôle concerné.
    noRoom = miss;
  }

  function roofColors() { return ROOFCOLORS[cfg.roofMat] || ROOFCOLORS["Bardeau d'asphalte"]; }
  function effRoofColor() { var l = roofColors(); return l.indexOf(cfg.roofColor) >= 0 ? cfg.roofColor : l[0]; }
  function pitchLocked() { return cfg.roof === "Toit plat"; }
  function noFinish() { return /sans/i.test(cfg.finish || ""); }

  /* Les résumés sont assemblés à partir de GABARITS traduits, pas de fragments recollés.
     Un gabarit porte son propre ordre de mots : « murs de {h} en {f} » devient « {h} walls in {f} ».
     Recoller des morceaux aurait donné « walls 8 ft in 2 × 6 ». Les valeurs (cfg.door, cfg.doorColor,
     cfg.svcSide…) ne bougent pas : seul leur AFFICHAGE passe par lab(). */
  function fmt(tpl, map) {
    return String(tpl).replace(/\{(\w+)\}/g, function (m, k) { return map[k] == null ? m : map[k]; });
  }
  var SVC_SPEC = "34 × 84";
  function svcPhrase(color) {
    var m = { spec: SVC_SPEC, u: tr("u_in", "po"), c: color ? lab(color).toLowerCase() : "" };
    return color ? fmt(tr("sum_c_svc_color", "porte de service {spec} {u} {c}"), m)
                 : fmt(tr("sum_c_svc", "porte de service {spec} {u}"), m);
  }
  function winPhrase() {
    if (cfg.windows === "0") return tr("sum_no_window", "aucune fenêtre");
    var n = parseInt(cfg.windows, 10) || 0;
    var m = { n: n, c: lab(cfg.winColor).toLowerCase() };
    return fmt(n === 1 ? tr("sum_c_win_one", "{n} fenêtre {c}") : tr("sum_c_win_many", "{n} fenêtres {c}"), m);
  }
  function doorSpec() {
    if (isGar()) {
      var g = cfg.gdoors, m = { w: lab(cfg.gdoorW), c: lab(cfg.doorColor).toLowerCase() };
      var head = g === "0" ? tr("sum_no_gdoor", "Aucune porte de garage")
        : fmt(g === "2" ? tr("sum_c_gdoor_2", "Deux portes de garage {w} {c}") : tr("sum_c_gdoor_1", "Porte de garage {w} {c}"), m);
      return head + (cfg.service === "Oui" ? " · " + svcPhrase(cfg.serviceColor) : "");
    }
    var d = fmt(tr("sum_c_door", "{D} {c}"), { D: lab(cfg.door), d: lab(cfg.door).toLowerCase(), C: lab(cfg.doorColor), c: lab(cfg.doorColor).toLowerCase() });
    return d + " · " + lab(cfg.doorSide).toLowerCase() + (cfg.service === "Oui" ? " · " + svcPhrase(null) : "");
  }
  function sidingPhrase() {
    return noFinish() ? tr("sum_nofinish", "sans finition (latte + Tyvek)")
      : fmt(tr("sum_c_siding", "revêtement {s} {c}"), { s: lab(cfg.siding).toLowerCase(), c: lab(cfg.color).toLowerCase() });
  }
  function roofingPhrase() { return fmt(tr("sum_c_roofing", "toiture {c}"), { c: lab(effRoofColor()).toLowerCase() }); }
  function overhangPhrase(v) { return fmt(tr("sum_c_overhang", "débord {o}"), { o: lab(v) }); }
  function floorPhrase() { return cfg.floor === FLOORS[1] ? tr("sum_floor_concrete", "plancher de béton") : tr("sum_floor_wood", "plancher de bois"); }
  function kindLabel() { return isGar() ? tr("sum_garage", "Garage") : tr("sum_shed", "Cabanon"); }
  function framingLabel() { return effFraming() === "2x6" ? "2 × 6" : "2 × 4"; }

  function hasAnyChoice(){ return Object.keys(selected).some(function(k){ return !!selected[k]; }); }
  function confirmedSummary(){
    var p = [kindLabel()];
    if (selected.size) p.push(fmt(tr("sum_s_size", "grandeur {size} {u}"), { size: cfg.size, u: tr("u_ft", "pi") }));
    if (selected.wall) p.push(fmt(tr("sum_s_walls", "murs {h}"), { h: lab(effWall()) }));
    if (selected.framing) p.push(framingLabel());
    if (selected.roof || selected.pitch) p.push(fmt(pitchLocked() ? tr("sum_c_roof", "toit {roof}") : tr("sum_s_roof_pitch", "toit {roof} {pitch}/12"),
      { roof: lab(cfg.roof).toLowerCase(), pitch: effPitch() }));
    if (isGar()) p.push(overhangPhrase("16 po"));
    else if (selected.overhang) p.push(overhangPhrase(effOverhang()));
    if (selected.finish || selected.siding || selected.color) p.push(noFinish() ? tr("sum_nofinish_short", "sans finition") : sidingPhrase());
    if (selected.roofMat || selected.roofColor) p.push(roofingPhrase());
    if (isGar() && (selected.gdoors || selected.gdoorW || selected.gdoorH)) p.push(doorSpec().toLowerCase());
    if (!isGar() && (selected.door)) p.push(doorSpec().toLowerCase());
    if (selected.service && cfg.service === "Oui") p.push(svcPhrase(null));
    if (selected.windows || selected.winColor || selected.winStyle) p.push(winPhrase());
    if (!isGar() && (selected.floor)) p.push(floorPhrase());
    if ((selected.extras) && cfg.extras.length) p.push(fmt(tr("sum_s_extras", "ajouts : {list}"), { list: cfg.extras.map(lab).join(", ").toLowerCase() }));
    return p.join(" · ") + ".";
  }
  function quoteDetails() {
    return tr("q_details", "Configuration 3D — choix confirmés :") + " "
      + (hasAnyChoice() ? confirmedSummary() : tr("q_nochoice", "aucun choix confirmé"));
  }

  /* ---------------- groupes ---------------- */
  function nudge(key, cur, dis) {
    // Un glissement volontaire fige la position : l'ouverture devient manuelle et sert désormais
    // d'obstacle fixe aux ouvertures placées automatiquement.
    function hand() { if (key === "svcPos") cfg.svcPlacement = "manual"; }
    return [
      { l: "◀ " + tr("v_slide", "Glisser"), on: function () { if (!dis) { cfg[key] = Math.max(0, cur - 10); hand(); mark(key); } }, dis: dis },
      { l: tr("v_centre", "Centrer"), on: function () { if (!dis) { cfg[key] = 50; hand(); mark(key); } }, sel: !dis && isSel(key, 50), dis: dis },
      { l: tr("v_slide", "Glisser") + " ▶", on: function () { if (!dis) { cfg[key] = Math.min(100, cur + 10); hand(); mark(key); } }, dis: dis }
    ];
  }
  // Contrôles par fenêtre — la valeur qui fait autorité est cfg.openings.windows[i].
  // Les clés de « touché » restent compatibles : w1 → winSide/winPos, w2 → winSide2/winPos2,
  // puis winSide3/winPos3, winSide4/winPos4 pour les nouvelles.
  function winKey(i, which) { return which + (i === 0 ? "" : String(i + 1)); }
  function winAt(i) { return cfg.openings.windows[i]; }
  function pickWinWall(i, dis) {
    return SIDES.map(function (o) {
      var w = winAt(i);
      return { l: lab(o), sel: !!selected[winKey(i, "winSide")] && !!w && w.wall === o, dis: dis,
        on: function () { if (!dis && winAt(i)) { winAt(i).wall = o; winAt(i).placement = "auto"; mark(winKey(i, "winSide")); } } };
    });
  }
  // Orientation visuelle. Le moteur place les fenêtres en coordonnées monde (pos qui augmente = +x
  // ou +z) alors que, vu de l'extérieur (caméra de focusSide), la droite de l'écran est −x sur le
  // mur arrière et −z sur le côté droit. La valeur stockée garde exactement son sens actuel — tous
  // les liens partagés conservent leur emplacement visuel — et seule l'interface tient compte du mur :
  //   affichage % : 0 = bord gauche tel qu'on le voit, 100 = bord droit, sur chaque mur ;
  //   ◀ / ▶ : déplacent toujours la fenêtre vers la gauche / la droite telles qu'on les voit.
  var WIN_MIRRORED = { "Arrière": true, "Côté droit": true };
  function winMirrored(w) { return !!(w && WIN_MIRRORED[w.wall]); }
  function winVisualPos(w) { return winMirrored(w) ? 100 - w.pos : w.pos; }
  function nudgeWinPos(i, dis) {
    function set(v) { var w = winAt(i); if (!dis && w) { w.pos = Math.max(0, Math.min(100, v)); w.placement = "manual"; mark(winKey(i, "winPos")); } }
    var w0 = winAt(i), cur = w0 ? w0.pos : 50, dir = winMirrored(w0) ? -1 : 1;
    return [
      { l: "◀ " + tr("v_slide", "Glisser"), on: function () { set(cur - dir); }, dis: dis },
      { l: tr("v_centre", "Centrer"), on: function () { set(50); }, sel: !dis && !!selected[winKey(i, "winPos")] && cur === 50, dis: dis },
      { l: tr("v_slide", "Glisser") + " ▶", on: function () { set(cur + dir); }, dis: dis }
    ];
  }
  function winGroupNames() {
    var out = [];
    for (var i = 0; i < cfg.openings.windows.length; i++) { out.push("win_wall_" + (i + 1)); out.push("win_pos_" + (i + 1)); }
    return out;
  }
  function pick(list, key, disAll, mapLabel, okFn) {
    return list.map(function (o) {
      var ok = okFn ? okFn(o) : true;
      return { l: mapLabel ? mapLabel(o, ok) : (ok ? lab(o) : lab(o) + " " + tr("v_unavailable", "(indisponible)")), sel: isSel(key, o), dis: disAll || !ok, on: function () { if (!disAll && ok) { cfg[key] = o;
        // Changer de mur, ou activer la porte de service, redonne la main au placement automatique.
        if (key === "svcSide" || (key === "service" && o === "Oui")) cfg.svcPlacement = "auto";
        mark(key); } } };
    });
  }
  function groups() {
    var g = [];
    g.push({ k: "size", t: tr("g_size", "GRANDEUR"), cur: lab(cfg.size), opts: pick(SIZES[cfg.kind].concat(["Sur mesure"]), "size") });
    g.push({ k: "wall", t: tr("g_wall", "HAUTEUR DES MURS"), cur: lab(effWall()), opts: pick(isGar() ? WALLS.slice(1) : ["7 pi", "8 pi"], "wall") });
    g.push({
      k: "framing", t: tr("g_framing", "COLOMBAGE"), cur: effFraming() === "2x6" ? "2 × 6" : "2 × 4",
      opts: FRAMING.filter(function (f) { return isGar() || f.v === "2x4"; }).map(function (f) {
        return { l: f.l, sel: (selected.framing) && effFraming() === f.v, on: function () { cfg.framing = f.v; mark("framing"); } };
      })
    });
    if (!isGar()) g.push({ k: "floor", t: tr("g_floor", "PLANCHER"), cur: cfg.floor === FLOORS[1] ? tr("v_concrete", "béton") : tr("v_wood", "bois"), opts: pick(FLOORS, "floor") });
    g.push({ k: "roof", t: tr("g_roof", "FORME DU TOIT"), cur: lab(cfg.roof), opts: pick(ROOFS.filter(function (o) { return isGar() || (!/truss/i.test(o) && o !== "Toit plat"); }), "roof") });
    g.push({
      k: "pitch", t: tr("g_pitch", "PENTE DU TOIT"), cur: pitchLocked() ? tr("v_pitch_locked", "imposée par la forme") : effPitch() + "/12",
      opts: PITCHES.map(function (p) {
        var ok = pitchOk(p) && !pitchLocked();
        return { l: pitchOk(p) ? p + "/12" : p + "/12 " + tr("v_pitch_max", "(max {max}/12 pour cette grandeur)").replace("{max}", maxPitchCab()), sel: (selected.pitch) && !pitchLocked() && effPitch() === p, dis: !ok, on: function () { if (ok) { cfg.pitch = p; mark("pitch"); } } };
      })
    });
    if (!isGar()) g.push({ k: "overhang", t: tr("g_overhang", "DÉBORD DE TOIT"), cur: lab(effOverhang()), opts: pick(CABOVER, "overhang") });
    g.push({ k: "overhang_color", t: tr("g_overhang_color", "COULEUR DU DÉBORD"), cur: lab(cfg.overhangColor), opts: pick(["Noir", "Blanc"], "overhangColor") });
    g.push({ k: "roof_mat", t: tr("g_roof_mat", "MATÉRIAU DE TOITURE"), cur: lab(cfg.roofMat), opts: pick(ROOFMATS, "roofMat") });
    g.push({
      k: "roof_color", t: tr("g_roof_color", "COULEUR DE TOITURE"), cur: lab(effRoofColor()),
      opts: roofColors().map(function (o) { return { l: lab(o), sel: (selected.roofColor) && effRoofColor() === o, on: function () { cfg.roofColor = o; mark("roofColor"); } }; })
    });
    g.push({ k: "finish", t: tr("g_finish", "FINITION EXTÉRIEURE"), cur: noFinish() ? tr("v_no_finish", "latte + Tyvek") : tr("v_with_finish", "avec revêtement"), opts: pick(FINISHES, "finish") });
    g.push({ k: "siding", t: tr("g_siding", "REVÊTEMENT"), cur: lab(cfg.siding), opts: pick(SIDINGS.filter(function (o) { return isGar() || o !== "Brique"; }), "siding") });
    g.push({ k: "color", t: tr("g_color", "COULEUR"), cur: lab(cfg.color), opts: pick(COLORS, "color") });
    if (isGar()) {
      g.push({
        k: "gdoors", t: tr("g_gdoors", "NOMBRE DE PORTES DE GARAGE"), cur: (cfg.gdoors === "0" ? tr("v_none_f", "aucune") : cfg.gdoors) + blockedTag(blocked.gdoors.length > 0, blocked.gdoorsWall),
        opts: GDOORCOUNT.map(function (o) {
          return { l: o === "0" ? tr("v_none_cap", "Aucune") : o, sel: (selected.gdoors) && cfg.gdoors === o, on: function () { cfg.gdoors = o; mark("gdoors"); } };
        })
      });
      g.push({
        k: "gdoor_w", t: tr("g_gdoor_w", "LARGEUR DE LA PORTE"), cur: cfg.gdoors === "0" ? "—" : lab(cfg.gdoorW) + blockedTag(blocked.gdoors.length > 0, blocked.gdoorsWall),
        opts: GDOORW.map(function (o) {
          var ok = cfg.gdoors !== "0";
          return { l: lab(o), sel: (selected.gdoorW) && cfg.gdoorW === o, dis: !ok, on: function () { if (ok) { cfg.gdoorW = o; mark("gdoorW"); } } };
        })
      });
      g.push({
        k: "gdoor_h", t: tr("g_gdoor_h", "HAUTEUR DE LA PORTE DE GARAGE"), cur: cfg.gdoors === "0" ? "—" : lab(effGdoorH()),
        opts: GDOORH.map(function (o) {
          var ok = hFits(o) && cfg.gdoors !== "0";
          return { l: hFits(o) ? lab(o) : lab(o) + " " + tr("v_walls_too_low", "(murs trop bas)"), sel: (selected.gdoorH) && effGdoorH() === o, dis: !ok, on: function () { if (ok) { cfg.gdoorH = o; mark("gdoorH"); } } };
        })
      });
      g.push({ k: "gdoor_color", t: tr("g_gdoor_color", "COULEUR DE LA PORTE DE GARAGE"), cur: lab(cfg.doorColor), opts: pick(TRIM, "doorColor", cfg.gdoors === "0") });
    } else {
      g.push({
        k: "door", t: tr("g_door", "PORTE"), cur: lab(cfg.door) + blockedTag(blocked.door, blocked.doorWall),
        opts: CABDOORS.map(function (o) {
          return { l: lab(o), sel: (selected.door) && cfg.door === o, on: function () { cfg.door = o; mark("door"); } };
        })
      });
      g.push({ k: "door_color", t: tr("g_door_color", "COULEUR DE LA PORTE"), cur: lab(cfg.doorColor), opts: pick(TRIM, "doorColor") });
    }
    g.push({ k: "door_side", t: tr("g_door_side", "POSITION DE LA PORTE"), cur: lab(cfg.doorSide) + blockedTag(blocked.door), opts: pick(SIDES, "doorSide") });
    g.push({ k: "door_pos", t: tr("g_door_pos", "GLISSER LA PORTE SUR SON MUR"), cur: cfg.doorPos === 50 ? tr("v_centred", "centrée") : cfg.doorPos + " %", opts: nudge("doorPos", cfg.doorPos, false), touched: !!selected.doorPos });
    g.push({ k: "service", t: tr("g_service", "PORTE DE SERVICE"), cur: cfg.service === "Oui" ? tr("v_included", "incluse") : tr("v_none_f", "aucune"), opts: pick(YESNO, "service") });
    var noSvc = cfg.service !== "Oui";
    g.push({ k: "svc_color", t: tr("g_svc_color", "COULEUR DE LA PORTE DE SERVICE"), cur: noSvc ? "—" : lab(cfg.serviceColor), opts: pick(TRIM, "serviceColor", noSvc) });
    // Le message « occupé » vient du moteur (calcul partagé), pas d'une estimation locale du panneau.
    // « Plus d'espace libre » explique le chevauchement signalé par la 3D : on n'affiche pas les deux.
    g.push({ k: "svc_side", t: tr("g_svc_side", "MUR DE LA PORTE DE SERVICE"), cur: noSvc ? "—" : lab(cfg.svcSide) + (noRoom.svc ? noRoomTag(true) : blockedTag(blocked.service)), opts: pick(SIDES, "svcSide", noSvc) });
    g.push({ k: "svc_pos", t: tr("g_svc_pos", "GLISSER LA PORTE DE SERVICE"), cur: noSvc ? "—" : cfg.svcPos + " %", opts: nudge("svcPos", cfg.svcPos, noSvc), touched: !!selected.svcPos });
    var noWin = cfg.windows === "0";
    g.push({ k: "windows", t: tr("g_windows", "NOMBRE DE FENÊTRES"), cur: noWin ? tr("v_none_f", "aucune") : cfg.windows, opts: pick(WINCOUNT, "windows", false, function (o, ok) { return o === "0" ? tr("v_none_cap", "Aucune") : o; }) });
    g.push({ k: "win_color", t: tr("g_win_color", "COULEUR DES FENÊTRES"), cur: noWin ? "—" : lab(cfg.winColor), opts: pick(TRIM, "winColor", noWin) });
    g.push({ k: "win_style", t: tr("g_win_style", "STYLE DE FENÊTRE"), cur: noWin ? "—" : lab(cfg.winStyle), opts: pick(WINSTYLES, "winStyle", noWin) });
    // Un bloc « mur » + « glisser » par fenêtre active, de la 1re à la 4e.
    cfg.openings.windows.forEach(function (w, i) {
      var n = i + 1;
      var sansPlace = noRoom.windows.indexOf(i) >= 0;
      g.push({ k: "win_wall_" + n, t: tr("g_win_wall", "MUR DE LA FENÊTRE") + " " + n, cur: lab(w.wall) + (sansPlace ? noRoomTag(true) : blockedTag(blocked.windows.indexOf(i) >= 0)), opts: pickWinWall(i, false) });
      g.push({ k: "win_pos_" + n, t: tr("g_win_pos", "GLISSER LA FENÊTRE") + " " + n, cur: winVisualPos(w) + " %", opts: nudgeWinPos(i, false), touched: !!selected[winKey(i, "winPos")] });
    });
    if (isGar()) g.push({
      k: "extras", t: tr("g_extras", "AJOUTS"), cur: cfg.extras.length ? cfg.extras.length + " " + (cfg.extras.length > 1 ? tr("v_selected_p", "sélectionnés") : tr("v_selected_s", "sélectionné")) : tr("v_none_m", "aucun"),
      opts: EXTRAS.map(function (o) {
        return { l: lab(o), sel: (selected.extras) && cfg.extras.indexOf(o) >= 0, on: function () { var i = cfg.extras.indexOf(o); if (i >= 0) cfg.extras.splice(i, 1); else cfg.extras.push(o); mark("extras"); } };
      })
    });
    return g;
  }

  /* ---------------- étapes ---------------- */
  function steps() {
    var G = groups();
    var byT = {}; G.forEach(function (x, i) { byT[x.k] = i; });
    function ids(names) { return names.map(function (n) { return byT[n]; }).filter(function (i) { return i != null; }); }
    var list = [
      { k: "st_size", t: tr("st_size", "Grandeur"), g: ids(["size"]), cur: cfg.size === "Sur mesure" ? lab("Sur mesure") : cfg.size + " " + tr("u_ft", "pi") },
      { k: "st_structure", t: tr("st_structure", "Structure"), g: ids(["wall", "framing", "floor"]), cur: fmt(tr("st_c_walls", "Murs {h}"), { h: lab(effWall()) }) + " · " + framingLabel() },
      { k: "st_roof", t: tr("st_roof", "Forme du toit"), g: ids(["roof", "pitch", "overhang", "overhang_color"]), cur: lab(cfg.roof) + (pitchLocked() ? "" : " · " + tr("st_pitch", "pente") + " " + effPitch() + "/12") + " · " + overhangPhrase(effOverhang()) },
      { k: "st_roofing", t: tr("st_roofing", "Toiture"), g: ids(["roof_mat", "roof_color"]), cur: lab(effRoofColor()) },
      { k: "st_siding", t: tr("st_siding", "Revêtement"), g: ids(["finish", "siding", "color"]), cur: noFinish() ? tr("st_nofinish", "Sans finition — latte + Tyvek") : fmt(tr("st_c_siding", "{S} {c}"), { S: lab(cfg.siding), s: lab(cfg.siding).toLowerCase(), C: lab(cfg.color), c: lab(cfg.color).toLowerCase() }) },
      {
        k: "st_doors", t: tr("st_doors", "Portes"),
        g: ids(isGar()
          ? ["gdoors", "gdoor_w", "gdoor_h", "gdoor_color", "door_side", "door_pos", "service", "svc_color", "svc_side", "svc_pos"]
          : ["door", "door_color", "door_side", "door_pos", "service", "svc_color", "svc_side", "svc_pos"]),
        cur: doorSpec()
      },
      { k: "st_windows", t: tr("st_windows", "Fenêtres"), g: ids(["windows", "win_color", "win_style"].concat(winGroupNames())), cur: winPhrase() }
    ];
    if (isGar()) list.push({ k: "st_extras", t: tr("st_extras", "Ajouts"), g: ids(["extras"]), cur: cfg.extras.length ? cfg.extras.map(lab).join(", ") : tr("v_none_m", "aucun") });
    return { steps: list, groups: G };
  }

  /* ---------------- rendu ---------------- */
  // Valeur COURANTE vs choix CONFIRMÉ (exigence A3). Chaque groupe et chaque étape affichent toujours
  // la valeur réellement en vigueur dans l'aperçu 3D ; tant que le client ne l'a pas choisie lui-même,
  // elle est marquée « à confirmer ». Une valeur d'aperçu n'est jamais présentée comme un choix client,
  // et « À choisir » ne masque plus jamais ce que la 3D affiche déjà.
  function withStatus(curText, isConfirmed) {
    if (isConfirmed || !curText || curText === "—") return curText;
    return curText + " · " + tr("to_confirm", "à confirmer");
  }
  var viewer = root.querySelector("proconex-3d");
  // Emplacements occupés, tels que signalés par le moteur 3D (intersection géométrique réelle des
  // empreintes dessinées, calculée UNE seule fois dans proconex-configurator.js). Le panneau n'a
  // aucune règle propre : il affiche ce que le moteur a réellement pu dessiner. La position demandée
  // reste intacte dans l'état ; le client garde ses contrôles pour la corriger.
  var blocked = { windows: [], service: false, door: false, gdoors: [], doorWall: false, gdoorsWall: false };
  var BLOCKED_MSG = tr("msg_blocked", "Emplacement occupé — déplacez cette ouverture");
  var WALL_MSG = tr("msg_wall", "Dépasse le mur — trop large pour ce mur");
  // Distinct de BLOCKED_MSG : ici rien ne chevauche, c'est le mur qui n'a plus d'intervalle libre.
  var NOROOM_MSG = tr("msg_noroom", "Plus d'espace libre sur ce mur — choisissez un autre mur ou agrandissez le bâtiment");
  function noRoomTag(on) { return on ? " · " + NOROOM_MSG : ""; }
  function blockedTag(isBlocked, isWall) { return isBlocked ? " · " + (isWall ? WALL_MSG : BLOCKED_MSG) : ""; }
  var stepsEl = root.querySelector("[data-pcfg-steps]");
  var sumEl = root.querySelector("[data-pcfg-summary]");
  var kindBtns = root.querySelectorAll("[data-pcfg-kind]");
  // Les puces Cabanon/Garage suivent cfg.kind (restauration ?cfg=, changement manuel), jamais l'inverse.
  function syncKindChips() { kindBtns.forEach(function (x) { x.classList.toggle("is-on", x.getAttribute("data-pcfg-kind") === cfg.kind); }); }
  var resetBtn = root.querySelector("[data-pcfg-reset]");
  var sendBtn = root.querySelector("[data-pcfg-send]");
  var shareBtn = root.querySelector("[data-pcfg-share]");

  /* La caméra suit la CLÉ du groupe, plus son libellé : le comportement ne dépend donc plus de la
     langue affichée. Les murs passés à focusSide restent les valeurs internes françaises. */
  function focusViewerFor(key) {
    if (!viewer || typeof viewer.focusSide !== "function") return;
    var k = String(key || "");
    var mw = /^win_(?:wall|pos)_([1-4])$/.exec(k);
    if (k === "svc_side" || k === "svc_pos" || k === "svc_color" || k === "service") viewer.focusSide(cfg.svcSide || "Avant");
    else if (mw) {
      var ww = cfg.openings.windows[parseInt(mw[1], 10) - 1];
      viewer.focusSide(ww ? ww.wall : "Avant");
    }
    else if (k === "st_windows" || k === "windows" || k === "win_color" || k === "win_style") viewer.focusSide((cfg.openings.windows[0] || {}).wall || "Avant");
    else if (k === "st_doors" || k.indexOf("door") === 0 || k.indexOf("gdoor") === 0) viewer.focusSide(cfg.doorSide || "Avant");
    else viewer.focusSide("Avant");
  }

  function syncViewer() {
    if (!viewer) return;
    var d = dims();
    var attrs = {
      kind: cfg.kind, w: d[0], d: d[1], wall: parseFloat(effWall()),
      framing: effFraming(), roof: cfg.roof, pitch: pitchLocked() ? "4" : effPitch(),
      siding: cfg.siding, color: cfg.color, finish: cfg.finish,
      roofmat: cfg.roofMat.indexOf("Tôle") === 0 ? "Tôle d'acier" : "Bardeau",
      roofcolor: effRoofColor(), overhang: effOverhang(), overhangcolor: cfg.overhangColor,
      gdoors: cfg.gdoors, gdoorw: cfg.gdoorW, gdoorh: parseFloat(effGdoorH()),
      door: doorSpec(), doorcolor: cfg.doorColor, doorside: cfg.doorSide, doorpos: cfg.doorPos,
      service: cfg.service, servicecolor: cfg.serviceColor, svcside: cfg.svcSide, svcpos: cfg.svcPos,
      svcw: 34, svch: 84,
      windows: cfg.windows, wincolor: cfg.winColor, winstyle: cfg.winStyle,
      winside: cfg.winSide, winpos: cfg.winPos, winside2: cfg.winSide2, winpos2: cfg.winPos2,
      // Pont structuré Phase 2 : la collection complète (0 à 4). Les attributs plats ci-dessus
      // restent émis pour les pages/liens anciens qui ne connaissent que winside/winpos.
      windowsdata: JSON.stringify(cfg.openings.windows.map(function (w) { return { wall: w.wall, pos: w.pos }; })),
      extras: cfg.extras.join(",")
    };
    Object.keys(attrs).forEach(function (k) { viewer.setAttribute(k, String(attrs[k])); });
  }

  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }

  /* ---- rendu sans saut ----------------------------------------------------------------------
     Le panneau est reconstruit à chaque changement (les options offertes dépendent les unes des
     autres), mais la reconstruction ne doit jamais faire perdre sa place au client :
       1. le nouvel arbre est construit hors document puis échangé sans jamais vider le conteneur —
          le document ne rétrécit pas, donc le défilement n'est jamais recadré par le navigateur ;
       2. l'animation d'entrée du corps d'étape ne rejoue que si l'étape ouverte a changé ;
       3. les listes déroulantes ouvertes et leur défilement interne sont conservés ;
       4. le bouton qui avait le focus le retrouve, sans défilement ;
       5. l'élément de référence (bouton cliqué, sinon focus, sinon en-tête ouvert) est remis à la
          même hauteur d'écran par une compensation instantanée du défilement — jamais scrollIntoView. */
  var lastOpenStep = -2;
  var anchorEl = null; // bouton cliqué, mémorisé par le gestionnaire juste avant render()
  function fieldTitle(node) { var f = node && node.closest ? node.closest(".pcfg__field") : null; var t = f && f.querySelector(".pcfg__lab span"); return t ? t.textContent : null; }
  function findField(title) { var fs = stepsEl.querySelectorAll(".pcfg__field"); for (var i = 0; i < fs.length; i++) { var t = fs[i].querySelector(".pcfg__lab span"); if (t && t.textContent === title) return fs[i]; } return null; }
  function findChip(title, label) { var f = findField(title); if (!f) return null; var cs = f.querySelectorAll(".chip"); for (var i = 0; i < cs.length; i++) if (cs[i].textContent === label) return cs[i]; return null; }
  function findHead(title) { var hs = stepsEl.querySelectorAll(".pcfg__head"); for (var i = 0; i < hs.length; i++) { var b = hs[i].querySelector("b"); if (b && b.textContent === title) return hs[i]; } return null; }
  function refOf(node) {
    if (!node || !stepsEl.contains(node)) return null;
    if (node.classList.contains("chip")) return { kind: "chip", title: fieldTitle(node), label: node.textContent };
    var h = node.closest ? node.closest(".pcfg__head") : null;
    if (h) { var b = h.querySelector("b"); return { kind: "head", title: b ? b.textContent : "" }; }
    return null;
  }
  function resolveRef(r) { return !r ? null : r.kind === "chip" ? findChip(r.title, r.label) : findHead(r.title); }
  function scrollByInstant(dy) {
    var root = document.documentElement, prev = root.style.scrollBehavior;
    root.style.scrollBehavior = "auto"; // html{scroll-behavior:smooth} rendrait la compensation visible
    window.scrollBy(0, dy);
    root.style.scrollBehavior = prev;
  }

  function render() {
    // 1. état d'interface à conserver
    var act = document.activeElement;
    var focusRef = (act && stepsEl.contains(act) && act.classList.contains("chip")) ? refOf(act) : null;
    var anchorNode = (anchorEl && stepsEl.contains(anchorEl)) ? anchorEl : (act && stepsEl.contains(act)) ? act : stepsEl.querySelector(".pcfg__step.is-open .pcfg__head");
    var anchorRef = refOf(anchorNode);
    var anchorTop = anchorNode ? anchorNode.getBoundingClientRect().top : null;
    var openDetails = {}, ddScroll = {};
    Array.prototype.forEach.call(stepsEl.querySelectorAll(".pcfg__field"), function (f) {
      var t = f.querySelector(".pcfg__lab span"), d = f.querySelector("details"), p = f.querySelector(".pcfg__ddp");
      if (!t) return;
      var gk = f.getAttribute("data-gk") || t.textContent;
      if (d && d.open) openDetails[gk] = true;
      if (p && p.scrollTop) ddScroll[gk] = p.scrollTop;
    });
    var stepChanged = openStep !== lastOpenStep; lastOpenStep = openStep;
    anchorEl = null;

    // 2. construction hors document
    var S = steps();
    var frag = document.createDocumentFragment();
    S.steps.forEach(function (st, i) {
      var wrap = el("div", "pcfg__step");
      var head = el("button", "pcfg__head"); head.type = "button";
      var num = el("span", "pcfg__num", "0" + (i + 1));
      var mid = el("span", "pcfg__mid");
      mid.appendChild(el("b", null, st.t));
      var STEP_KEYS = isGar()
        ? [["size"],["wall","framing"],["roof","pitch","overhangColor"],["roofMat","roofColor"],["finish","siding","color"],["gdoors","gdoorW","gdoorH","doorColor","doorSide","doorPos","service","serviceColor","svcSide","svcPos"],["windows","winColor","winStyle","winSide","winPos","winSide2","winPos2","winSide3","winPos3","winSide4","winPos4"],["extras"]]
        : [["size"],["wall","framing","floor"],["roof","pitch","overhang","overhangColor"],["roofMat","roofColor"],["finish","siding","color"],["door","doorColor","doorSide","doorPos","service","serviceColor","svcSide","svcPos"],["windows","winColor","winStyle","winSide","winPos","winSide2","winPos2","winSide3","winPos3","winSide4","winPos4"]];
      var chosenStep = (STEP_KEYS[i] || []).some(function(k){ return !!selected[k]; });
      var cur = el("span", "pcfg__cur", withStatus(st.cur, chosenStep)); mid.appendChild(cur);
      var caret = el("span", "pcfg__caret", "⌄");
      head.appendChild(num); head.appendChild(mid); head.appendChild(caret);
      if (i === openStep) { wrap.className += " is-open"; }
      head.addEventListener("click", function () { anchorEl = head; openStep = openStep === i ? -1 : i; render(); if(openStep===i) focusViewerFor(st.k); });
      wrap.appendChild(head);
      if (i === openStep) {
        var body = el("div", "pcfg__body");
        if (!stepChanged) body.style.animation = "none"; // même étape : pas de glissement d'entrée
        st.g.forEach(function (gi) {
          var grp = S.groups[gi];
          var fld = el("div", "pcfg__field");
          fld.setAttribute("data-gk", grp.k);
          var labEl = el("div", "pcfg__lab");
          var groupHasSel = ("touched" in grp) ? !!grp.touched : grp.opts.some(function(o){ return !!o.sel; });
          labEl.appendChild(el("span", null, grp.t));
          labEl.appendChild(el("i", null, withStatus(grp.cur, groupHasSel)));
          fld.appendChild(labEl);
          var many = grp.opts.length >= 5;
          var host = fld;
          if (many) {
            var det = document.createElement("details");
            if (openDetails[grp.k]) det.open = true; // liste laissée ouverte par le client
            var sum = el("summary", "pcfg__dd");
            var selNow = grp.opts.filter(function (o) { return o.sel; })[0];
            sum.appendChild(el("span", null, selNow ? selNow.l : withStatus(grp.cur, false)));
            sum.appendChild(el("span", "pcfg__ddc", "▾"));
            det.appendChild(sum);
            host = el("div", "pcfg__ddp");
            det.appendChild(host);
            fld.appendChild(det);
          }
          var row = el("div", "pcfg__chips");
          grp.opts.forEach(function (o) {
            var b = el("button", "chip" + (o.sel ? " is-on" : "") + (o.dis ? " is-off" : ""), o.l);
            b.type = "button";
            b.addEventListener("click", function () {
              if (o.dis) return;
              anchorEl = b; o.on(); reflowOpenings(); render(); syncViewer(); focusViewerFor(grp.k);
            });
            row.appendChild(b);
          });
          host.appendChild(row);
          body.appendChild(fld);
        });
        wrap.appendChild(body);
      }
      frag.appendChild(wrap);
    });

    // 3. échange sans jamais vider le conteneur (on ajoute d'abord, on retire l'ancien ensuite)
    var old = Array.prototype.slice.call(stepsEl.childNodes);
    stepsEl.appendChild(frag);
    old.forEach(function (n) { stepsEl.removeChild(n); });

    // 4. restaurer défilement des listes, focus, puis hauteur d'écran de la référence
    Object.keys(ddScroll).forEach(function (t) { var f = stepsEl.querySelector('.pcfg__field[data-gk="' + t + '"]') || findField(t), p = f && f.querySelector(".pcfg__ddp"); if (p) p.scrollTop = ddScroll[t]; });
    var fc = resolveRef(focusRef);
    if (fc) { try { fc.focus({ preventScroll: true }); } catch (e0) { try { fc.focus(); } catch (e1) {} } }
    var ac = resolveRef(anchorRef);
    if (ac && anchorTop != null) {
      var delta = ac.getBoundingClientRect().top - anchorTop;
      if (Math.abs(delta) > 0.5) scrollByInstant(delta);
    }
    if (sumEl) sumEl.textContent = hasAnyChoice() ? confirmedSummary() : tr("none_confirmed", "Aucun choix confirmé — ouvrez les étapes dans l’ordre qui vous convient.");
  }

  // Bascule Cabanon / Garage : architecture par page. Sur la page Cabanon, « Garage » mène à la page
  // Garage (et inversement) ; le type de la page courante reste local. Un lien partagé ?cfg= restaure
  // toujours son type sur place (jamais de redirection automatique, donc jamais de boucle).
  var pageKind = root.getAttribute("data-pcfg-page-kind") || cfg.kind;
  kindBtns.forEach(function (b) {
    b.addEventListener("click", function () {
      var k = b.getAttribute("data-pcfg-kind");
      var target = root.getAttribute("data-pcfg-url-" + k) || "";
      if (k !== pageKind && target && target.charAt(0) !== "#") { window.location.assign(target); return; }
      if (k === cfg.kind) return;
      cfg = defaults(k); selected = {}; openStep = 0;
      syncKindChips();
      reflowOpenings(); render(); syncViewer();
    });
  });
  if (resetBtn) resetBtn.addEventListener("click", function () { cfg = defaults(cfg.kind); selected = {}; openStep = 0; render(); syncViewer(); });
  // Partage : la feuille système quand elle existe, sinon le presse-papiers. Elle ne reçoit QUE le
  // titre et l'URL — aucun texte séparé, aucune charge utile dans « text » : c'est ce qui faisait
  // arriver dans Messages un second message contenant la chaîne encodée en entier.
  function legacyCopy(text) {
    try {
      var ta = document.createElement("textarea");
      ta.value = text; ta.setAttribute("readonly", ""); ta.setAttribute("aria-hidden", "true");
      ta.style.cssText = "position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;pointer-events:none";
      document.body.appendChild(ta); ta.focus(); ta.select(); ta.setSelectionRange(0, text.length);
      var ok = document.execCommand("copy");
      document.body.removeChild(ta);
      return !!ok;
    } catch (e) { return false; }
  }
  var shareTimer = 0;
  if (shareBtn) {
    shareBtn.setAttribute("aria-live", "polite");
    shareBtn.addEventListener("click", function () {
      var url = configLink();
      if (!shareBtn.getAttribute("data-pcfg-label")) shareBtn.setAttribute("data-pcfg-label", shareBtn.textContent);
      var label = shareBtn.getAttribute("data-pcfg-label");
      var copiedTxt = tr("share_copied", "Lien copié ✓");
      function feedback(t) {
        shareBtn.textContent = t;
        if (shareTimer) clearTimeout(shareTimer);
        shareTimer = setTimeout(function () { shareBtn.textContent = label; shareTimer = 0; }, 2400);
      }
      function fallback() {
        if (legacyCopy(url)) { feedback(copiedTxt); return; }
        feedback(label);
        window.prompt("Copiez ce lien", url); // dernier recours : le lien exact reste visible et sélectionnable
      }
      function copier() {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () { feedback(copiedTxt); }, fallback);
        } else { fallback(); }
      }
      // navigator.share doit partir du geste de l'utilisateur, donc directement ici.
      if (navigator.share) {
        try {
          navigator.share({ title: tr("share_title", "Configuration Proconex"), url: url })
            // La feuille système affiche son propre retour ; on ne superpose pas de message,
            // et surtout on n'invente pas une chaîne qui n'existe pas dans les fichiers de langue.
            .then(function () { feedback(label); })
            .catch(function (err) {
              // Annulation de la feuille système : on ne copie pas derrière le dos du client.
              if (err && (err.name === "AbortError" || err.name === "NotAllowedError")) { feedback(label); return; }
              copier();
            });
          return;
        } catch (e) { /* implémentation incomplète : on retombe sur le presse-papiers */ }
      }
      copier();
    });
  }

  if (sendBtn) sendBtn.addEventListener("click", function () {
    try {
      var cfgLink = configLink();
      sessionStorage.setItem("proconex:config", JSON.stringify({
        type: isGar() ? "Garage" : "Cabanon",
        details: asFrench(quoteDetails),   // ce que Proconex reçoit : toujours français
        detailsUi: quoteDetails(),         // ce que le client relit : sa langue
        link: cfgLink
      }));
    } catch (e) { }
    var dest = sendBtn.getAttribute("data-href") || "/pages/soumission";
    dest += (dest.indexOf("?") >= 0 ? "&" : "?") + "ptype=" + encodeURIComponent(isGar() ? "Garage" : "Cabanon");
    window.location.href = dest;
  });

  if (viewer) viewer.addEventListener("proconex:windows-rendered", function (e) {
    var d = e.detail || {}, b = d.blocked || {};
    var ops = d.openings || [];
    var wallHit = function (id) { return ops.some(function (p) { return p.id === id && p.hit === "wall"; }); };
    var next = { windows: (b.windows || d.conflicts || []).slice(), service: !!b.service, door: !!b.door, gdoors: (b.gdoors || []).slice(),
      doorWall: wallHit("door"), gdoorsWall: (b.gdoors || []).some(function (i) { return wallHit("gdoor" + (i + 1)); }) };
    if (JSON.stringify(next) === JSON.stringify(blocked)) return; // pas de re-rendu inutile
    blocked = next;
    render(); // render() seul : il ne réécrit pas les attributs du moteur, donc aucune boucle
  });

  syncKindChips(); reflowOpenings(); render(); syncViewer();

  document.addEventListener('proconex:set-size', function (e) {
    var v = e.detail && e.detail.size;
    if (!v) return;
    cfg.size = v; mark("size");
    openStep = 0; reflowOpenings(); render(); syncViewer();
  });
  var _emitSize = function () { try { document.dispatchEvent(new CustomEvent('proconex:size-changed', { detail: { size: cfg.size } })); } catch (er) { }
  };
  var _render0 = render;
  render = function () { _render0(); _emitSize(); };
  _emitSize();
  })();
